// schemas/validationSchema.js
import * as Yup from "yup";

export const ArtistValidationSchema = Yup.object({
  name: Yup.string().required("Name is required"),
  email: Yup.string().email("Invalid email").required("Email is required"),
  // experience: Yup.number()
  //   .typeError("Must be a number")
  //   .required("Experience is required"),
  // skills: Yup.array().min(1, "Select at least 1 skill"),
  // bio: Yup.string().required("Bio is required"),
  image: Yup.mixed().required("Profile picture is required"),
  password: Yup.string()
    .min(6, "Password must be at least 6 characters")
    .required("Password is required"),
  confirm_password: Yup.string()
    .oneOf([Yup.ref("password"), null], "Passwords must match")
    .required("Confirm Password is required"),
});
